<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        class="ma-1 mr-10"
        fab
        color="primary"
        top
        right
        absolute
        v-on="on"
      >
        <v-icon>
          mdi-plus
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Training Session"
      text="Add Training Sessions"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <v-btn-toggle
                v-model="isStaff"
                mandatory
              >
                <v-btn>
                  <span class="hidden-sm-and-down">Staff</span>
                </v-btn>

                <v-btn>
                  <span class="hidden-sm-and-down">Non-staff</span>
                </v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col
              v-if="isStaff == 0"
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="instructor"
                v-validate="'required'"
                :error-messages="errors.collect('instructor')"
                :items="instructors"
                data-vv-name="instructor"
                item-text="person.name"
                item-value="employee_uid"
                label="Instructor"
                return-object
              />
            </v-col>

            <v-col
              v-if="isStaff !=0"
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="instructorName"
                v-validate="'required'"
                :error-messages="errors.collect('instructor name')"
                data-vv-name="instructor name"                
                label="Instructor Name"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="name"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"                
                label="Training Session Name"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-menu
                id="date"
                v-model="datemenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="selectedDateDisplay"
                    v-validate="'required'"
                    label="Date"
                    prepend-icon="event"
                    :error-messages="errors.collect('date')" 
                    data-vv-name="date"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="date"
                  class="datepicker"
                  no-title
                  @input="datemenu = false"
                />
              </v-menu>    
            </v-col>
    
            <v-col
              cols="12"
              class="py-0"
            >
              <v-menu
                v-model="timeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="timeNow"
                    v-validate="'required'"
                    label="Time"
                    prepend-icon="mdi-clock"
                    :error-messages="errors.collect('time')"
                    data-vv-name="time"  
                    readonly
                    v-on="on"
                  />
                </template>

                <v-time-picker
                  ref="picker"
                  v-model="time"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="timeMenu = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="venue"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('venue')"
                data-vv-name="venue"                
                label="Venue"
              />
            </v-col>
    
            <v-col
              cols="12"
              class="py-0"
            >
              <v-text-field
                v-model="description"
                v-validate="'required|max:255'"
                :error-messages="errors.collect('description')"
                data-vv-name="description"                
                label="Training Description"
              />
            </v-col>

            <v-col
              cols="12"
              class="py-0"
            >
              <v-autocomplete
                v-model="moderator"
                v-validate="'required'"
                :error-messages="errors.collect('moderator')"
                :items="moderators"
                data-vv-name="moderator"
                item-text="person.name"
                item-value="employee_uid"
                label="Moderator"
                return-object
              />
            </v-col>
          </v-row>
        </v-container>
      </form>
      
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>

        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    props: {
      courseId: {
        type: Number,
        default: null,
      },
    },
 
    data () {
      return {
        name: null,
        progressing: false,
        dialog: null,
        description: null,
        venue: null,
        time: null,
        instructorName: null,
        datemenu: false,
        date: null,
        instructors: [],
        instructor: null,
        isStaff: 0,
        moderators: [],
        moderator: null,
        timeMenu: false,
      }
    },

    computed: {
      selectedDateDisplay () {
        if (!this.date) return
        return this.$moment(this.date, 'YYYY-MM-DD').format('D MMM YYYY')
      },
      timeNow () {
        if (!this.time) return
        return this.formatTime(this.time)
      },
 
    },

    watch: {
      dialog: function (value) {
        if (!value) {
          this.$resetData()
        } else {
          this.$api.trainingSessionInstructors().list()
            .then((res) => {
              this.instructors = res.data
            })

          this.$api.trainingSessionModerators().list()
            .then((res) => {
              this.moderators = res.data
            })
        }
      },
    },
    methods: {    
      formatTime (time) {
        let a = (time || '').split(':') // split it at the colons
        let seconds = (a[0] * 60 * 60) + (a[1] * 60)

        return this.$moment(new Date(1970, 0, 1).setSeconds(seconds)).format('hh:mm A')
      },
        
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 

            this.progressing = true

            this.$api.trainingSessions().create(this.prepareFormData())
              .then((res) => {
                if (res.status === 201) {
                  this.$emit('created', res.data)                
                  this.$snack({ message: 'Training Session Created Succesfully' })

                  this.dialog = false                
                }
              })
              .catch(() => {})
              .then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        let data = {
          name: this.name,
          course_id: this.courseId,
          date: this.date,
          description: this.description,
          time: this.time + ':00',
          venue: this.venue,
          moderator_uid: this.moderator.employee_uid,
        }

        if (this.isStaff !== 0) {
          Object.assign(data, { instructor_name: this.instructorName })
        } else {
          Object.assign(data, { instructor_uid: this.instructor.employee_uid })
          Object.assign(data, { instructor_name: this.instructor.person.name })
        }

        return data
      },
    },
  }
</script>
